import { useCallback, useEffect, useRef } from 'react';

import { runWhenIdle } from '#/lib/run-when-idle';
import { identifyWithoutId, useAnalytics } from '#/lib/segment';

export const SessionAnalytics: React.FC = () => {
  const analytics = useAnalytics();
  const scrollFired = useRef(false);
  const timerFired = useRef(false);
  const identifiedAsEngaged = useRef(false);

  const markEngaged = useCallback(() => {
    if (identifiedAsEngaged.current) return;
    identifiedAsEngaged.current = true;
    identifyWithoutId({ engagedUser: true });
  }, []);

  useEffect(() => {
    const onScroll = () => {
      if (!scrollFired.current && window.scrollY >= 300) {
        scrollFired.current = true;
        window.removeEventListener('scroll', onScroll);
        // Batch track + identify off the scroll turn so the next tap isn't delayed.
        runWhenIdle(() => {
          void analytics.track('Scrolled Past 300px');
          markEngaged();
        });
      }
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, [analytics, markEngaged]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (!timerFired.current) {
        timerFired.current = true;
        runWhenIdle(() => {
          void analytics.track('Session Exceeded 5s');
          markEngaged();
        });
      }
    }, 5_000);

    return () => clearTimeout(timeout);
  }, [analytics, markEngaged]);

  return null;
};
